import React from "react";

export const INTENTS = [
    { key: "apologize", label: "Apologize" },
    { key: "follow_up", label: "Follow-up" },
    { key: "set_boundary", label: "Set Boundary" },
    { key: "ask_favor", label: "Ask Favor" },
    { key: "clarify", label: "Clarify" },
    { key: "express_concern", label: "Express Concern" },
    { key: "love", label: "Love" },
];

const IntentPresets = ({ value, onChange }) => {
    return (
        <div
            data-testid="intent-presets"
            className="w-full overflow-x-auto no-scrollbar"
        >
            <div className="flex items-center gap-1.5 sm:gap-2 px-1 py-1 min-w-max">
                {INTENTS.map((it) => {
                    const active = value === it.key;
                    return (
                        <button
                            key={it.key}
                            type="button"
                            data-testid={`intent-chip-${it.key}`}
                            data-active={active}
                            aria-pressed={active}
                            onClick={() =>
                                onChange(active ? null : it.key)
                            }
                            className={`shrink-0 inline-flex items-center gap-1.5 text-[12px] font-medium rounded-full px-3 py-1.5 border transition-colors ${
                                active
                                    ? "bg-[#5E7153] text-white border-[#5E7153] shadow-sm"
                                    : "bg-card text-foreground/70 border-border hover:text-foreground hover:bg-muted"
                            }`}
                        >
                            {active && (
                                <span className="h-1.5 w-1.5 rounded-full bg-white/90" />
                            )}
                            {it.label}
                        </button>
                    );
                })}
                {value && (
                    <button
                        type="button"
                        data-testid="intent-clear"
                        onClick={() => onChange(null)}
                        className="shrink-0 inline-flex items-center text-[11px] text-muted-foreground hover:text-foreground px-2 py-1 ml-1"
                        aria-label="Clear intent"
                    >
                        Clear
                    </button>
                )}
            </div>
        </div>
    );
};

export default IntentPresets;
